import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div className='row justify-content-center pt-3 g-0 mt-3'>

            <div className='col-md-5 p-3'>
                <img className='mb-3' src="./img/cplogo-hdpi.png" alt="" width={200}/>
                <p className='text-white fs-6'>En Centro Pokémon podrás encontrar la más reciente información y noticias sobre Pokémon, así como guías, eventos, descargas, foros y mucho más. Pokémon y el resto de nombres relacionados son propiedad de Nintendo, Creatures Inc y Game Freak 1996-2023.</p>
            </div> 
            <div className='col-md-4 p-3'>
                <div className='d-flex flex-column flex-md-row'>
                    <ul className='d-flex flex-column pe-3'>
                        <p className='text-white fw-bold h4'>Sitio</p>
                        <li><a href="https://www.centropkmn.com/seccion/cp/acerca-de/">Acerca de</a></li>
                        <li><a href="https://www.facebook.com/groups/cpokemon.oficial" target='_blank' rel='noreferrer nofollow'>Grupo de Facebook</a></li>
                        <li><a href="https://www.centropkmn.com/seccion/cp/legal/">Aviso legal</a></li>
                        <li><a href="https://www.centropkmn.com/seccion/cp/contacto/">Contacto</a></li>
                    </ul>
                    <ul className='d-flex flex-column'>
                        <p className='text-white fw-bold h4'>Guías</p>
                        <li><a href="https://www.centropkmn.com/escarlata-purpura/">Pokémon Scarlet & Violet</a></li>
                        <li><a href="https://www.centropkmn.com/leyendas-arceus/">Pokémon Legends: Arceus</a></li>
                        <li><a href="https://www.centropkmn.com/pokemon-espada-escudo/">Pokémon Sword & Shield</a></li>
                        <li><a href="https://www.centropkmn.com/letsgo/">Pokémon Let's GO Pikachu! & Eevee!</a></li>
                        <li><a href="https://www.centropkmn.com/ultrasunmoon/">Pokémon Ultrasun & Ultramoon</a></li>
                        <li><a href="https://www.centropkmn.com/sunmoon/">Pokémon Sun & Moon</a></li>
                        <li><a href="https://www.centropkmn.com/pokemon-oras/">Pokémon Omega Ruby & Alpha Saphire</a></li>
                        <li><a href="https://www.centropkmn.com/pokemon-xy/">Pokémon X & Y</a></li>
                    </ul>
                </div>
            </div>
            <div className='d-flex flex-md-row flex-column justify-content-center text-white bgCopyright pt-3 px-3'>
            
            <p className='me-4 text-center'>Centro Pokémon 2005-2023. Todos los derechos reservados del contenido original.</p>
            <p className='text-center'><img src="https://www.centropkmn.com/wp-content/themes/nuevocp/images/arg.png" alt='Bandera Argentina' style={{verticalAlign: "middle", marginRight: "0px"}}></img> <img src="https://www.centropkmn.com/wp-content/themes/nuevocp/images/cri.png" alt='Bandera Costa Rica' style={{verticalAlign: "middle", marginRight: "0px"}}></img> Creado en Argentina y Costa Rica</p>
        </div>
        </div>

    </footer>
  )
}

export default Footer